<template>
    <card class="card-pricing bg-gradient-default border-0 text-center mb-3"
        header-classes="bg-transparent"
        body-classes="px-lg-7"
        footer-classes="bg-transparent"
        v-if="registration && simulation">

        <simulation-info :registration="registration" :simulation="simulation"></simulation-info>

        <div class="display-3 text-white mb-3">
            <span class="text-muted d-inline">{{ registration.degree.name }} /</span>
            {{ simulation.name }}
        </div>

        <base-progress class="mb-0" type="info" :value="progress(simulation)">
        </base-progress>

        <div class="text-center text-white mb-4" style="margin-top:-10px;">
            {{ progress(simulation) }}% {{ $t('dashboard.done').toLowerCase() }}
        </div>

        <div class="row mb-4" v-if="simulation.state.from">
            <div class="col-lg-12 text-center pb-2">
                <span class="icon icon-xs icon-shape bg-white shadow rounded-circle">
                    <i class="fas fa-calendar-alt"></i>
                </span>
                <span class="pl-2 text-sm text-white">
                    <span class="text-muted">{{ $t('common.from') }}</span> {{ date(simulation.state.from) }}
                    <span class="text-muted">{{ $t('common.to').toLowerCase() }}</span> {{ date(simulation.state.to) }}
                </span>
            </div>
        </div>

        <div class="mb-2" v-if="!simulation.assessment">

            <base-button type="secondary" @click="openLog" v-if="!simulation.remedial">
                {{ $t('common.log') }}
            </base-button>

            <base-button type="secondary" @click="openSharedFeedbacks"
                v-if="!simulation.remedial && $permissions.hasRight('dashboard.shared-feedbacks.read')"
            >
                {{ $t('feedbacks.shared-feedbacks') }}
                <span class="pl-1" v-if="sharedFeedbacks">
                    ({{ sharedFeedbacks.count }})
                </span>
            </base-button>

        </div>

        <portal to="modals" v-if="$permissions.hasRight('dashboard.shared-feedbacks.read')">
            <base-modal size="lg"
                v-model="modals.sharedFeedbacks"
                :title="$t('feedbacks.shared-feedbacks')"
                body-classes="py-0"
            >
                <shared-feedbacks :registration="registration" :simulation="simulation"
                    :modal="modals.sharedFeedbacks" :competencies="competencies">
                </shared-feedbacks>
            </base-modal>
        </portal>
    </card>
</template>

<script>
    import ModalsController from '@trax/classes/ModalsController'
    import SimulationInfo from '../common/SimulationInfo'
    import SharedFeedbacks from '../../log/common/SharedFeedbacks'
    import moment from 'moment'

    export default {

        components: {
            SharedFeedbacks, SimulationInfo
        },

        props: {

            registration: {
                type: Object,
            },

            simulation: {
                type: Object,
            },

            competencies: {
                type: Array,
                default: []
            },
        },

        data() {
            return {
                modals: new ModalsController('sharedFeedbacks'),
                moment: moment,
                sharedFeedbacks: null
            }
        },

        methods: {

            setSharedFeedbacks(sharedFeedbacks) {
                this.sharedFeedbacks = sharedFeedbacks
            },

            openSharedFeedbacks() {
                this.modals.open('sharedFeedbacks')
            },

            openLog() {
                this.$router.push({
                    name: 'log',
                    params: {
                        registrationId: this.$route.params.registrationId,
                        simulationId: this.simulation.id,
                        groupId: this.$route.params.groupId ? this.$route.params.groupId : 0,
                    }
                });
            },

            progress(simulation) {
                if (simulation.state.sessions_count == 0) {
                    return 0
                }
                let progress = (simulation.state.completed_sessions ? simulation.state.completed_sessions : 0) * 100 / simulation.state.sessions_count
                return parseInt(progress)
            },

            date(date) {
                return this.moment(date).format('DD/MM/YYYY')
            }
        }
    }
</script>

<style scoped>

    .card-pricing >>> .progress {
        background-color: #57587D;
    }

</style>
